import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

const FAQQuestion = ({ data }) => {
  const [showContent, setShowContent] = useState(false)
  
  return (
    <div className={`faq__question ${showContent ? 'faq__question__open': ''}`}>
      <div className='faq__question__title' onClick={() => { setShowContent(!showContent) }}>
        <span>{data.title}</span>
        {!showContent && <FontAwesomeIcon icon={faPlusCircle} />}
        {showContent && <FontAwesomeIcon icon={faMinusCircle} />}
      </div>
      <div className={`faq__question__content`}>
        {data.content}
      </div>
    </div>  
  )
}

export default FAQQuestion;